import ReactModal from 'react-modal';
import General from '../utils/GeneralUtils';
import UniversalTag from './UniversalTag';
import './EmailVerificationSlideout.scss';

const PHONE_UNIQUENESS_STATUSES = [
  {
    key: 'UNIQUE',
    description: 'This phone number is not shared with other contacts or institutions within the Edulead system.',
  },
  {
    key: 'SHARED_CONTACT',
    description: 'This phone number is shared with other contacts, or is a general institution number (e.g., main office line).',
  },
];

interface PhoneUniquenessSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PhoneUniquenessSlideout({ isOpen, onClose }: PhoneUniquenessSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 450px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="email-verification-slideout">
        <div className="header">
          <h3>Phone Uniqueness</h3>
        </div>

        <div className="section intro">
          <p>Indicates whether a phone number is unique to this contact or shared with others.</p>
        </div>

        <div className="section all-statuses">
          <table>
            <tbody>
              {PHONE_UNIQUENESS_STATUSES.map((statusInfo) => (
                <tr key={statusInfo.key}>
                  <td className="status-cell">
                    <UniversalTag category={statusInfo.key} />
                  </td>
                  <td className="desc">{statusInfo.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </ReactModal>
  );
}
